module.exports = __webpack_public_path__ + "img/map-marker-green.0918c2e5.svg";